import { createContext, useContext } from "react";
import type { ExecutionMetrics, WarningEntry } from "@/types/api";

export interface AgentExecutionContextValue {
  outputs: Record<string, unknown> | null;
  status: "idle" | "running" | "completed" | "failed" | "paused";
  executionId: string | null;
  isRunning: boolean;
  isComplete: boolean;
  tokens: string;
  metrics: ExecutionMetrics | null;
  warnings: WarningEntry[];
  // Props needed to render Output/Chat inside agent-specific tabs
  projectId?: string;
  agentId?: string;
  showOutput?: boolean;
  reportContent?: string;
  // Past runs
  selectedExecutionId?: string | null;
  isViewingPastRun?: boolean;
  // Snapshot por varredura (FA full-base): id da varredura selecionada no
  // histórico (null = consolidado). As abas filtram o catálogo por ele.
  selectedScanId?: string | null;
  setSelectedScanId?: (id: string | null) => void;
}

const AgentExecutionContext = createContext<AgentExecutionContextValue>({
  outputs: null,
  status: "idle",
  executionId: null,
  isRunning: false,
  isComplete: false,
  tokens: "",
  metrics: null,
  warnings: [],
  projectId: undefined,
  agentId: undefined,
  showOutput: false,
  reportContent: "",
  selectedExecutionId: null,
  isViewingPastRun: false,
  selectedScanId: null,
  setSelectedScanId: undefined,
});

export const AgentExecutionProvider = AgentExecutionContext.Provider;

export function useAgentExecutionContext() {
  return useContext(AgentExecutionContext);
}
